import { Link } from "react-router-dom";
import { animeList } from "@/mocks/anime";

export default function RankSection() {
  const top = [...animeList].sort((a, b) => b.score - a.score).slice(0, 5);
  const maxScore = top[0]?.score ?? 9;

  return (
    <section className="bg-background-900/40 py-10 md:py-14">
      <div className="container-site grid gap-10 lg:grid-cols-2">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50 md:text-3xl">
            <i className="ri-trophy-line text-primary-500" />
            高分口碑榜
          </h2>
          <p className="mt-1 text-sm text-foreground-400">站内综合评分最高的年度佳作</p>
          <div className="mt-6 space-y-3">
            {top.map((a, i) => (
              <Link
                key={a.id}
                to={`/detail/${a.id}`}
                className="flex items-center gap-3 rounded-lg border border-background-800 bg-background-900 p-3 transition-colors hover:border-primary-700"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                    i === 0
                      ? "bg-primary-500 text-background-950"
                      : i === 1
                      ? "bg-secondary-500/80 text-background-950"
                      : "bg-background-700 text-foreground-200"
                  }`}
                >
                  {i + 1}
                </span>
                <img src={a.cover} alt={a.title} title={`${a.title} 高分番剧`} className="h-12 w-20 shrink-0 rounded-md object-cover object-top" />
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-100">{a.title}</h3>
                  <p className="mt-0.5 text-xs text-foreground-500">{a.category} · {a.episodes} 集</p>
                </div>
                <span className="flex items-center gap-1 text-sm font-bold text-accent-400">
                  <i className="ri-star-fill" />
                  {a.score.toFixed(1)}
                </span>
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-col justify-center rounded-xl border border-background-800 bg-background-900/70 p-6 md:p-8">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-500/10 px-3 py-1 text-xs font-medium text-primary-400">
            <i className="ri-cpu-line" /> 全站数据
          </span>
          <h3 className="mt-4 font-heading text-2xl text-foreground-50 md:text-3xl">资源规模一目了然</h3>
          <div className="mt-6 grid grid-cols-2 gap-4">
            {[
              { n: "1280+", t: "收录番剧", i: "ri-movie-2-line" },
              { n: "1.2w+", t: "分集资源", i: "ri-folder-video-line" },
              { n: "300w+", t: "累计播放", i: "ri-eye-line" },
              { n: "4K/1080P", t: "高清画质", i: "ri-hd-line" },
            ].map((s) => (
              <div key={s.t} className="rounded-lg border border-background-800 bg-background-950/40 p-4">
                <i className={`${s.i} text-xl text-primary-400`} />
                <p className="mt-2 font-heading text-2xl text-foreground-50">{s.n}</p>
                <p className="mt-1 text-xs text-foreground-400">{s.t}</p>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm leading-relaxed text-foreground-400">
            覆盖热血、奇幻、科幻、恋爱、悬疑等多类型动画，全集收录 + 高清下载，一站式满足漫迷找番、看番、存番的全部需求。
          </p>
          <Link to="/list" className="btn-primary mt-6 w-fit">
            开始找番 <i className="ri-arrow-right-line ml-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}